module.exports = __webpack_public_path__ + "static/media/tamborine_100bpm.c6436106.mp3";